export const Vendors = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_3597_87715)">
        <path
          d="M4.5 9.72277V19.5C4.5 19.6989 4.57902 19.8897 4.71967 20.0303C4.86032 20.171 5.05109 20.25 5.25 20.25H18.75C18.9489 20.25 19.1397 20.171 19.2803 20.0303C19.421 19.8897 19.5 19.6989 19.5 19.5V9.34777"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.0625 3.75H18.9375C19.1004 3.75003 19.2589 3.80311 19.389 3.90122C19.519 3.99932 19.6136 4.13711 19.6584 4.29375L21 9H3L4.34438 4.29375C4.38904 4.13757 4.48321 4.00012 4.61272 3.90206C4.74222 3.804 4.90006 3.75064 5.0625 3.75Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g clipPath="url(#clip1_3597_87715)">
          <path
            d="M12.1875 17.25C13.6372 17.25 14.8125 16.0747 14.8125 14.625C14.8125 13.1753 13.6372 12 12.1875 12C10.7378 12 9.5625 13.1753 9.5625 14.625C9.5625 16.0747 10.7378 17.25 12.1875 17.25Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.25 19.5469C9.04447 18.1741 10.4874 17.25 12.1875 17.25C13.8876 17.25 15.3305 18.1741 16.125 19.5469"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3597_87715">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_3597_87715">
          <rect
            width="10.5"
            height="10.5"
            fill="white"
            transform="translate(6.82507 10.0978)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
